import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL, NOTNULL_OR_NOTUNDEFINED } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class PendingActionClient {
  static baseUrl = BASE_URL + "/new";

  static getNscPendingActionsNotifications(user, selectedMarket = null) {
    let url = `${this.baseUrl}/nsc/pending-actions`;

    if (selectedMarket !== null) {
      url = url.concat(`?selectedMarket=${selectedMarket}&userType=nsc`);
    }

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => response.data.result)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getDealerPendingActionsNotifications(user, marketID = null) {
    const viewAll =
      user.dealerGroup && user.dealerGroup.length > 1 && user.showAll;
    const dealerIds = viewAll
      ? user.getDealerIdsWithoutSDLR()
      : user.getDealerIdsWithSDLR();

    let url = `${this.baseUrl}/dealer/pending-actions?dealerIds=${dealerIds}`;
    if (marketID !== null) {
      url = url.concat(`&selectedMarket=${marketID}&userType=${user.userType}`);
    }
    return axios
      .get(url, getHeaders(user.token))
      .then((response) => response.data.result)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static removeNscPendingAction(user, action, vehicleLines, selectedMarket) {
    let url = `${this.baseUrl}/pending-actions?action=${action}`;
    if (NOTNULL_OR_NOTUNDEFINED(vehicleLines)) {
      url += "&vehicleLines=" + vehicleLines;
    }
    if (NOTNULL_OR_NOTUNDEFINED(selectedMarket)) {
      url += "&selectedMarket=" + selectedMarket;
    }
    return this.deletePA(user, url);
  }

  static deletePA(user, url) {
    return axios.delete(url, getHeaders(user.token)).catch((error) => {
      if (is401(error)) {
        AuthenticationFailureHandler.execute();
      }
      return Promise.reject(error);
    });
  }

  static addPA(user, action, selectedMarket) {
    const url = `${this.baseUrl}/pending-actions?action=${action}&selectedMarket=${selectedMarket}`;
    return axios.put(url, null, getHeaders(user.token)).catch((error) => {
      if (is401(error)) {
        AuthenticationFailureHandler.execute();
      }
      return Promise.reject(error);
    });
  }

  static removeDealerPendingAction(
    user,
    dealerIds,
    action,
    vehicleLines,
    deliveryEnabled,
    actionId
  ) {
    let url = `${this.baseUrl}/pending-actions?action=${action}&dealerIds=${dealerIds}`;
    if (NOTNULL_OR_NOTUNDEFINED(vehicleLines)) {
      url += "&vehicleLines=" + vehicleLines;
    }
    if (NOTNULL_OR_NOTUNDEFINED(deliveryEnabled)) {
      url += "&deliveryEnabled=" + deliveryEnabled;
    }

    if (NOTNULL_OR_NOTUNDEFINED(actionId)) {
      url += "&actionId=" + actionId;
    }

    return this.deletePA(user, url);
  }

  static getHasNscCompletedPA(user, version, marketID = null) {
    let url = `${this.baseUrl}/pending-actions/completion?version=${version}`;

    if (marketID !== null) {
      url = url.concat(`&selectedMarket=${marketID}`);
    }

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
  static updatePendingAction(user, market, catalogId, paActive) {
    let url = `${this.baseUrl}/pending-actions/update`;
    url += `?market=${market}`;
    url += `&catalogId=${catalogId}`;
    url += `&paActive=${paActive}`;
    return axios.put(url, null, getHeaders(user.token)).catch((error) => {
      if (is401(error)) {
        AuthenticationFailureHandler.execute();
      }
      return Promise.reject(error);
    });
  }
  static updateInfoAction(user, market, catalogId, infoActive) {
    let url = `${this.baseUrl}/pending-actions/info-update`;
    url += `?market=${market}`;
    url += `&catalogId=${catalogId}`;
    url += `&infoActive=${infoActive}`;
    return axios.put(url, null, getHeaders(user.token)).catch((error) => {
      if (is401(error)) {
        AuthenticationFailureHandler.execute();
      }
      return Promise.reject(error);
    });
  }
}
